import React from 'react';
import { Modals } from '@material-bank/projects-dialogs';
import { createRoot } from 'react-dom/client';

const projectModalRootSelector = document.getElementById('project-modals-root');
if (projectModalRootSelector) {
  createRoot(projectModalRootSelector).render(<Modals />);
}
